/** Forme structurelle minimale acceptée par les filtres : couvre à la fois les
 * sorties v2 (``MeetingParticipantOut`` / ``OpinionParticipantOut`` où ``role``
 * est optionnel/nullable et ``hidden`` absent côté opinion) et les types v1. */
type FilterableParticipant = {
  role?: { intranet_id?: number | null } | null;
  hidden?: boolean | null;
};

export function internFilter(participant: FilterableParticipant) {
  return (
    participant.role?.intranet_id === 0 &&
    ("hidden" in participant ? !participant.hidden : true)
  );
}

export function supervisorFilter(participant: FilterableParticipant) {
  return participant.role?.intranet_id !== 0 && !participant.hidden;
}

export function visibleFilter(participant: FilterableParticipant) {
  return !participant.hidden;
}
